const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-surface font-body text-on-surface-variant selection:bg-primary-fixed selection:text-on-primary-fixed overflow-hidden relative">
      {/* BAGIAN ATAS (Header Logo) */}
      <header className="top-0 left-0 w-full absolute flex justify-between items-center px-8 py-6">
        <div className="text-xl font-bold tracking-tight text-slate-900">
          Sistem Inventaris
        </div>
        <div className="flex items-center gap-2">
          <span className="material-symbols-outlined text-slate-500">
            help_outline
          </span>
        </div>
      </header>

      {/* BAGIAN TENGAH (Isi Formulir) */}
      <main className="min-h-screen flex items-center justify-center p-6 relative">
        {/* Elemen Dekorasi Latar Belakang (Bulatan Berwarna) */}
        <div className="absolute top-1/4 -left-20 w-96 h-96 bg-secondary-fixed opacity-20 rounded-full blur-[100px]"></div>
        <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-primary-fixed opacity-20 rounded-full blur-[100px]"></div>

        {/* 'children' adalah tempat di mana formulir Login/Daftar disisipkan */}
        <div className="w-full flex justify-center z-10">{children}</div>
      </main>

      {/* BAGIAN BAWAH (Footer Hak Cipta) */}
      <footer className="bottom-0 w-full absolute flex flex-col items-center justify-center space-y-4 pb-8">
        <div className="text-[9px] uppercase tracking-widest text-slate-400 opacity-50">
          © 2026 Sistem Inventaris. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout;
